import { ChangeEvent, Checkbox, Label, Panel } from "@mcleod/components";
import { CommonDialogs } from "../CommonDialogs";
import { MenuEditorTreeNode } from "./MenuEditorTreeNode";
import { MenuEditorUtil } from "./MenuEditorUtil";

export class MenuEditorDialogs {

    public static async showDeleteMenuItemDialog(node: MenuEditorTreeNode): Promise<MenuEditorTreeNode[]> {
        const result = await CommonDialogs.showDestructive({ text: `Are you sure you want to delete ${node.menuItem.caption}?` }, "Delete Menu Item");
        return result ? [node] : null;
    }

    public static async showDeleteSharedItemsDialog(nodesToDelete: MenuEditorTreeNode[]): Promise<MenuEditorTreeNode[]> {
        const itemCaption = nodesToDelete[0].menuItem.caption;
        const msg = `${itemCaption} is part of a shared menu. Deleting it will remove it from all locations:`;
        const panel = MenuEditorUtil.createReferencePanel(msg, nodesToDelete);

        const result = await CommonDialogs.showDestructive(panel,
            "Delete Menu Item",
            {
                yesButtonProps: { caption: "Delete All" },
                noButtonProps: { caption: "Cancel" },
                focusContentOnShow: false,
                resizable: true
            }
        );
        return result ? nodesToDelete : null;
    }


    public static async showDeleteSharedReferencesDialog(nodesToDelete: MenuEditorTreeNode[]): Promise<MenuEditorTreeNode[]> {
        if (nodesToDelete.length === 0) {
            return null;
        }
        const msg = `${nodesToDelete[0].menuItem.caption} is included in multiple menus. Choose which locations to remove it from:`;
        const panel = Panel.createNoMarginNoPaddingPanel();
        panel.add(new Label({text: msg, marginBottom: 16, fillRow: true}));

        const selectedNodes: Set<MenuEditorTreeNode> = new Set();

        // present a checkbox for each node to delete
        nodesToDelete.forEach((node, index) => {
            const checkbox = new Checkbox({ caption: node.getPathAsString() });

            checkbox.addChangeListener((event: ChangeEvent) => {
                event.newValue ? selectedNodes.add(node) : selectedNodes.delete(node);
            });

            // the first node (assumed to be the tree's selected node) is checked by default
            if (index === 0) {
                checkbox.checked = true;
            }
            panel.add(checkbox);
        });

        const dialogPromise = CommonDialogs.showDestructive( panel,
            "Remove Included Submenu",
            {
                yesButtonProps: {caption: "Remove Selected"},
                noButtonProps: {caption: "Cancel"},
                focusContentOnShow: false,
                resizable: true,
                width: 500
            }
        );

        const result = await dialogPromise;
        return result ? Array.from(selectedNodes) : null;
    }
}
